var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "step_4" } }, [
    !_vm.$root.is_male
      ? _c("img", {
          staticStyle: { "max-width": "200px", width: "100%" },
          attrs: { src: require("../img/waist-hip-size.png") },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("h2", [
        _vm._v(
          "What are " +
            _vm._s(_vm.$root.is_mini_or_baby ? "their" : "your") +
            " waist and hip measurements?"
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", [
          _c("p", [
            _c("strong", [_vm._v("Natural waist:")]),
            _vm._v(
              " Measure around the narrowest part of " +
                _vm._s(_vm.$root.is_mini_or_baby ? "their" : "your") +
                "\n          waist.\n        "
            ),
          ]),
          _vm._v(" "),
          !_vm.$root.use_centimeters
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.$root.waist_size,
                    expression: "$root.waist_size",
                    modifiers: { lazy: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  placeholder: "waist",
                  type: "number",
                  step: "0.5",
                  autofocus: "",
                  required: "",
                },
                domProps: { value: _vm.$root.waist_size },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.$root,
                      "waist_size",
                      $event.target.value
                    )
                  },
                },
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.$root.waist_size,
                    expression: "$root.waist_size",
                    modifiers: { lazy: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  placeholder: "waist",
                  type: "number",
                  step: "0.5",
                  autofocus: "",
                  required: "",
                },
                domProps: { value: _vm.$root.waist_size },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.$root,
                      "waist_size",
                      $event.target.value
                    )
                  },
                },
              }),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("p", [
            _c("strong", [_vm._v("Hips:")]),
            _vm._v(
              " Measure around the fullest part of " +
                _vm._s(_vm.$root.is_mini_or_baby ? "their" : "your") +
                " hips."
            ),
          ]),
          _vm._v(" "),
          !_vm.$root.use_centimeters
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.$root.hip_size,
                    expression: "$root.hip_size",
                    modifiers: { lazy: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  placeholder: "hip",
                  type: "number",
                  step: "0.5",
                  required: "",
                },
                domProps: { value: _vm.$root.hip_size },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.$root, "hip_size", $event.target.value)
                  },
                },
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.$root.hip_size,
                    expression: "$root.hip_size",
                    modifiers: { lazy: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  placeholder: "hip",
                  type: "number",
                  step: "0.5",
                  required: "",
                },
                domProps: { value: _vm.$root.hip_size },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.$root, "hip_size", $event.target.value)
                  },
                },
              }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }